import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import cn from 'classnames';
import styles from './styles.scss';
import iconMessageClose from 'assets/images/icons/cross.svg';
import { withTranslation } from 'react-i18next';
// import iconClose from 'assets/images/icons/icon-close.svg';


class Notification extends Component {

  componentDidMount() {

  }

  componentWillUnmount() {
    this.clearTimeout();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (!this.props.show && nextProps.show) ||
      (this.props.message !== nextProps.message)
    ) {
      this.resetTimeout();
    }
  }

  resetTimeout = () => {
    this.clearTimeout();
    this.timeout = setTimeout(
      _ => {
        this.handleCloseClick();
      },
      this.props.timeout || this.props.status === 1 ? 6000 : 3000
    );
  }

  clearTimeout = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleCloseClick = () => {
    this.props.dispatch({ type: 'HIDE_NOTIFICATION' });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleCancelClick = () => {
    if (Array.isArray(this.props.cancel)) {
      Promise.all(
        this.props.cancel
        .filter(_ => _)
        .reverse()
        .map(
          cancel => this.props.dispatch(cancel())
        )
      ).then(
        () => this.props.dispatch({ type: 'CANCELATION_SUCCESS' })
      );
    } else {
      this.props.dispatch(this.props.cancel());
    }
  }

  handleMouseEnter = () => {
    this.clearTimeout();
  }

  handleMouseLeave = () => {
    this.resetTimeout();
  }

  render() {
    const { message, show, status = 0, cancel, t } = this.props;
    const color = this.props.color || (status === 1 ? '#e74c3c' : '#2ecc71');
    return (
      <div
        className={cn(styles.NotificationWrapper, { [styles.LowerNotification]: location.pathname.includes('building') })}
        style={{
          height: show ? '40px' : '0px'
        }}
      >
        <div
          className={styles.Notification}
          style={{
            height: '40px',
            opacity: (show && !this.props.isPopupOpen) ? 1 : 0,
            backgroundColor: color
          }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          { message }
          {
            status === 1 && cancel &&
            <span className={styles.Cancel} onClick={this.handleCancelClick} style={{ color }}>
              {t('components.notification.cancel')}
            </span>
          }
          <span className={styles.MessageClose} onClick={this.handleCloseClick}>
            <img src={iconMessageClose} alt="" />
          </span>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({ ...state.notification, isPopupOpen: !!state.environment.popUp })
)(withRouter(withTranslation()(Notification)));



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js